import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import CostiAnalisiPieSet from "./CostiAnalisi.PieSet";
import CostiAnalisiKPISet from "./CostiAnalisi.KPISet";

const CostiAnalisi = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showPIE = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Costs')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <CostiAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showPIE &&
                <CostiAnalisiPieSet dataProviderName={dataProviderName} filters={filters} />
            }

        </Box>
    )
}

export default CostiAnalisi;
